import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("TarefaResultadoFilter")
export class TarefaResultadoFilter {

  idTarefa: number;
}
